import * as SetDisplayModeActions from 'actions/SetDisplayMode';

export default function displayModeReducer(displayMode, action) {
    switch (action.type) {
        case SetDisplayModeActions.SET_DISPLAY_MODE:
            return action.data;
    }

    return displayMode;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/displayModeReducer.js